import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type BeneficiaryCreationFailedAction = {
	type: 'BENEFICIARY_CREATION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): BeneficiaryCreationFailedAction => ({
	type: 'BENEFICIARY_CREATION_FAILED',
	payload,
});
